import React from 'react';
import strawberry from '@/public/svg/fruit-strawberry-pink.svg';

type LoadingIconProps = {
    text: string;
    variant?: 'page' | 'inline';
};

const LoadingIcon: React.FC<LoadingIconProps> = ({ text, variant = 'page' }) => {
    if (variant === 'inline') {
        return (
            <span className="inline-flex items-center gap-2">
                <img
                    src={strawberry}
                    alt="Ladeanzeige"
                    loading="lazy"
                    className="h-8 w-8 animate-spin"
                />
                {text ? <span className="text-sm text-gray-500">{text}</span> : null}
            </span>
        );
    }

    return (
        <div className="mt-16">
            <div className="flex justify-center items-center h-[200px]">
                <img
                    src={strawberry}
                    alt="Ladeanzeige"
                    loading="lazy"
                    className="w-auto h-28 animate-spin"
                />
            </div>
            <p className="text-center text-gray-500">{text}</p>
        </div>
    );
};

export default LoadingIcon;
